import pluralize from 'helpers/pluralize';
import formatDate from 'helpers/formatDate';
import formatNumber from 'helpers/formatNumber';

import { metadataProps } from '../metadataPropTypes';
import shouldRenderValue from 'helpers/shouldRenderValue';
import { Meta } from '../Metadata.style';

/**
 * This component shows meta data of a release which is grouped.
 */
function GroupReleaseMetadata({
  groupChildCount,
  releaseDate,
  primaryArtist,
  showDetailedMetadata,
  displayName,
  topic,
}) {
  return (
    <Meta>
      {topic === 'social'
        ? shouldRenderValue(displayName) && <span>{displayName}</span>
        : shouldRenderValue(primaryArtist) && (
            <span>{`${
              showDetailedMetadata ? 'Release ' : ''
            }by ${primaryArtist}`}</span>
          )}
      {shouldRenderValue(releaseDate) && (
        <span>{`${formatDate(releaseDate, 'day-short')}`}</span>
      )}
      {shouldRenderValue(groupChildCount) && (
        <span className="versionsSpan">{`${formatNumber(
          groupChildCount
        )} ${pluralize('version', groupChildCount)}`}</span>
      )}
    </Meta>
  );
}

GroupReleaseMetadata.propTypes = {
  ...metadataProps,
};

export default GroupReleaseMetadata;
